import { render, staticRenderFns } from "./PurchaseTypeGroupComponent.vue?vue&type=template&id=45d3a2ff"
import script from "./PurchaseTypeGroupComponent.vue?vue&type=script&lang=ts"
export * from "./PurchaseTypeGroupComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports